/**
 * Centralised, typed access to Vite env. Use this instead of import.meta.env
 * directly so callers don't sprinkle string keys across the codebase.
 */

const env = import.meta.env

export const ENV = {
  appEnv: env.VITE_APP_ENV,
  isLocal: env.VITE_APP_ENV === 'mylocal',
  isDev: env.VITE_APP_ENV === 'dev',
  isDemo: env.VITE_APP_ENV === 'demo',
  isDevOrDemo:
    env.VITE_APP_ENV === 'dev' || env.VITE_APP_ENV === 'demo',
  isProd:
    env.VITE_APP_ENV === 'prod' ||
    env.VITE_APP_ENV === 'prod-eu' ||
    env.VITE_APP_ENV === 'prod-au',

  api: env.VITE_API_URI,
  graphql: env.VITE_GRAPHQL_URI,
  buyer: env.VITE_BASE_URI_BUYER,
  ua: env.VITE_BASE_URI_UA,
  directory: env.VITE_DIRECTORY_URI,
  vendors: env.VITE_VENDORS_URI,
  process: env.VITE_PROCESS_URI,
  product: env.VITE_PRODUCT_URI,
  comm: env.VITE_COMM_URI,
  forms: env.VITE_FORMS_URI,
  masterdata: env.VITE_MASTERDATA_BASE_URL,
  customerdata: env.VITE_CUSTOMERDATA_BASE_URL,
  assets: env.VITE_ORO_ASSETS_BASE,
  runner: env.VITE_ORO_RUNNER_BASE_URI,

  // SSO / Auth0
  socialSigninUri: env.VITE_ORO_SOCIAL_SIGNIN_URI,
  socialSigninUriV2: env.VITE_ORO_SOCIAL_SIGNIN_URI_V2,
  socialSigninClientId: env.VITE_SOCIAL_SIGNIN_CLIENT_ID,
  socialSigninConnectionGoogle: env.VITE_SOCIAL_SIGNIN_CONNECTION_GOOGLE,
  socialSigninConnectionMicrosoft: env.VITE_SOCIAL_SIGNIN_CONNECTION_MICROSOFT,
  // Dev-only SSO buttons — surface when appEnv === 'dev' or 'mylocal'
  barSocialSigninClientId: env.VITE_BAR_SOCIAL_SIGNIN_CLIENT_ID,
  fooSocialSigninClientId: env.VITE_FOO_SOCIAL_SIGNIN_CLIENT_ID,

  // Optimizely
  optimizelySdkKey: env.VITE_OPTIMIZELY_SDK_KEY,
} as const

export type Env = typeof ENV
